import _template from 'lodash/template';
import { RecurrenceScheduleType } from 'modules/campaigns/lib/types';
import { EndRecurrenceType } from '../../types';

export const CONFIRM_SCHEDULE_CAMPAIGN_MODAL_TEST_ID = 'confirm-schedule-campaign-modal';
export const CONFIRM_SCHEDULE_CAMPAIGN_MODAL_CONFIRM_BUTTON_TEST_ID = `${CONFIRM_SCHEDULE_CAMPAIGN_MODAL_TEST_ID}-confirm-button`;
export const CONFIRM_SCHEDULE_CAMPAIGN_MODAL_DISCARD_BUTTON_TEST_ID = `${CONFIRM_SCHEDULE_CAMPAIGN_MODAL_TEST_ID}-discard-button`;

export const RECURRENCE_TYPE_LABEL_MAPPER = {
  [RecurrenceScheduleType.DoNotRepeat]: '',
  [RecurrenceScheduleType.Daily]: 'daily',
  [RecurrenceScheduleType.Weekly]: 'weekly',
  [RecurrenceScheduleType.BiWeekly]: 'every two weeks',
  [RecurrenceScheduleType.ThirtyDays]: 'every 30 days',
  [RecurrenceScheduleType.FirstOfTheMonth]: 'every first of the month',
  [RecurrenceScheduleType.FifteenTheOfTheMonth]: 'every 15th of the month',
  [RecurrenceScheduleType.LastOfTheMonth]: 'every last of the month',
  [RecurrenceScheduleType.Custom]: _template(
    'every <%= recurrenceFrequency %> day<%= pluralLetter %>',
  ),
};

export const END_RECURRENCE_TYPE_LABEL_MAPPER = {
  [EndRecurrenceType.Never]: 'does not end',
  [EndRecurrenceType.OnDate]: _template('ends after <%= endDate %>'),
};
